import apiPaths from 'config/apiPaths';

import axiosInstance from './axios';

export const runScript = async (scriptName: string): Promise<string> => {
  const { data } = await axiosInstance.post<string>(`${apiPaths.SCRIPTS}/${scriptName}`);
  return data;
};
